import React from 'react';
import PropTypes from 'prop-types';

export default function ACheckBox({
	id,
	value,
	onClick,
	className,
}) {
	return (
		<section className={`a-check-box ${className}`}>
			<input
				type="checkBox"
				id={id}
				value={value}
				onClick={onClick}
				checked={value}
			/>
			<label
				htmlFor={id}
				aria-checked="false"
				className="a-check-box"
			/>
		</section>
	);
}

ACheckBox.propTypes = {
	id: PropTypes.string.isRequired,
	className: PropTypes.string,
	value: PropTypes.bool,
	onClick: PropTypes.func,
};

ACheckBox.defaultProps = {
	value: false,
	className: '',
	onClick: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.checkbox.js